import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../additional/functions";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const uiremoteApi = createApi({
  reducerPath: "uiremoteApi",
  baseQuery,
  endpoints: (builder) => ({
    getAutomationList: builder.query({
      query: () => "/uiremote-desktop/automation-list",
      skip: true,
      transformResponse: (response) => {
        const formattedResponse = response.map((item) => item.process_name);
        return formattedResponse;
      },
    }),
    getDevicesInfo: builder.query({
      query: () => "/uiremote-desktop/get_devices_info",
    }),
    getMobileDevicesInfo: builder.query({
      query: () => "/uiremote-mobile/get_devices_info",
    }),
    postNewAutomation: builder.mutation({
      query: (newAutomationName) => ({
        url: "/uiremote-desktop/automation-list",
        method: "POST",
        body: { name: newAutomationName },
      }),
    }),
    sendUIRemoteCommand: builder.mutation({
      query: ({ command, devices }) => ({
        url: "/uiremote-desktop/send-command",
        method: "POST",
        body: { command: command, devices: devices },
      }),
    }),
    getBotsByProcess: builder.query({
      query: ({ requiredProcess, status, accountStatus }) => {
        const rawQuery = {
          process: requiredProcess,
          status,
          accountStatus,
        };
        const builtQuery = buildQuery(rawQuery);
        return `/uiremote-desktop/get-total-bots${builtQuery}`;
      },
    }),
  }),
});

export const {
  useGetAutomationListQuery,
  useGetDevicesInfoQuery,
  useGetMobileDevicesInfoQuery,
  usePostNewAutomationMutation,
  useSendUIRemoteCommandMutation,
  useGetBotsByProcessQuery,
} = uiremoteApi;
